import { render, staticRenderFns } from "./BrochureEdit.vue?vue&type=template&id=6b8b3e69&scoped=true&"
import script from "./BrochureEdit.vue?vue&type=script&lang=js&"
export * from "./BrochureEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrochureEdit.vue?vue&type=style&index=0&id=6b8b3e69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b3e69",
  null
  
)

export default component.exports